import { render, staticRenderFns } from "./marketingLandPageListShow.vue?vue&type=template&id=a10a9230&scoped=true&"
import script from "./marketingLandPageListShow.vue?vue&type=script&lang=js&"
export * from "./marketingLandPageListShow.vue?vue&type=script&lang=js&"
import style0 from "./marketingLandPageListShow.vue?vue&type=style&index=0&id=a10a9230&prod&lang=scss&scoped=true&"
import style1 from "./marketingLandPageListShow.vue?vue&type=style&index=1&id=a10a9230&prod&lang=scss&scoped=true&"
import style2 from "./marketingLandPageListShow.vue?vue&type=style&index=2&id=a10a9230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10a9230",
  null
  
)

export default component.exports